import { carsStore } from '.';
import { observable } from 'mobx';

import { api } from '../services';

class GroupsStore {
  @observable groups;
  @observable loading = false;

  constructor(carsStore) {
    this.carsStore = carsStore;
  }

  load() {
    this.loading = true;
    return api('get all groups').then(groups => {
      this.loading = false;
      this.groups = groups;
    });
  }

  async create(name, description, phoneNumber) {
    this.loading = true;
    await api('create group', name, description, phoneNumber);

    return this.load().then(() => ({}));
  }
  async update(id, name, description, phoneNumber) {
    this.loading = true;
    await api('update group', id, name, description, phoneNumber);
    return this.load().then(() => ({}));
  }

  async addVehicles(groupId, ...vehiclesIds) {
    return await api('add vehicles to group', groupId, ...vehiclesIds).then(response => {
      const { success } = response;
      if (success) {
        return new Promise(resolve => {
          this.carsStore.load().then(() => {
            resolve(response);
          });
        });
      } else {
        return response;
      }
    });
  }

  async delete(id) {
    this.loading = true;
    await api('delete group', id);
    return Promise.all([this.load(), this.carsStore.load()]);
  }
}

export default new GroupsStore(carsStore);



// WEBPACK FOOTER //
// ./src/stores/groupsStore.js